<template>
    <svg :width="size" :height="size" viewBox="0 0 202 202" role="img" aria-label="Springcast">
        <rect x="1.5" y="1.5" width="199" height="199" rx="46" fill="none" stroke="currentColor" :stroke-opacity="frameOpacity" stroke-width="3" />
        <g fill="currentColor">
            <rect x="54" y="41" width="98" height="15.5" rx="7.75" />
            <rect x="43" y="66.75" width="68" height="15.5" rx="7.75" />
            <rect x="64" y="92.5" width="78" height="15.5" rx="7.75" />
            <rect x="90" y="118.25" width="67" height="15.5" rx="7.75" />
            <rect x="48" y="144" width="99" height="15.5" rx="7.75" />
        </g>
    </svg>
</template>

<script setup>
defineProps({
    size: { type: Number, default: 30 },
    frameOpacity: { type: Number, default: 0.3 },
})
</script>
